import { useQuery } from "react-query";
import axios from "axios";

const getPortfolios = async () => {
  const { data } = await axios.get(`/api/v2/portfolios`);

  return data;
};
export default function usePortfolios() {
  return useQuery(["portfolios"], () => {
    return getPortfolios();
  });
}
